import React, { memo, useState } from "react";
import { ADMIN_LANG } from "../../../settings";
import { SelectData } from "../../../types/admin";
import { Col, Table } from "react-bootstrap";
import {Eye} from "react-bootstrap-icons";

// Memoized row component
const SelectTableRow = memo(({ option, onToggle }: { option: SelectData, onToggle: () => void }) => {
    const pointColor = option.points > 0 ? 'text-success' : (option.points < 0 ? 'text-danger' : 'text-muted');

    return (
        <>
            <tr onClick={onToggle} style={{ cursor: 'pointer' }}>
                <td>{option.name} {option.open_answers.length > 0 ?
                <span className='modal-link ms-3'><Eye/></span> : ''}</td>
                <td className={`text-center ${pointColor}`}>{option.points}</td>
                <td className="text-center">{option.selections} {ADMIN_LANG.times}</td>
            </tr>
            {/* Collapsible row for open answers */}
            {option.isOpen && option.open_answers.length > 0 && (
                <tr>
                    <td colSpan={3}>
                        <ul style={{'marginBottom': 0}}>
                            {option.open_answers.map((answer, index) => (
                                <li key={index}>{answer}</li>
                            ))}
                        </ul>
                    </td>
                </tr>
            )}
        </>
    );
});

const SelectTable = ({ optionsData }: { optionsData: SelectData[] }) => {
    const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());

    const toggleRow = (index: number) => {
        setExpandedRows(prev => {
            const newRows = new Set(prev);
            if (newRows.has(index)) {
                newRows.delete(index);
            } else {
                newRows.add(index);
            }
            return newRows;
        });
    };

    return (
        <Col xs={12} md={6}>
            <div className="admin-card">
                <Table responsive striped hover>
                    <thead>
                        <tr>
                            <th>{ADMIN_LANG.name}</th>
                            <th className="text-center">{ADMIN_LANG.points}</th>
                            <th className="text-center">{ADMIN_LANG.selections}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {optionsData.map((option, index) => (
                            <SelectTableRow
                                key={index}
                                option={{ ...option, isOpen: expandedRows.has(index) }} // Pass expanded state
                                onToggle={() => toggleRow(index)} // Pass the toggle function
                            />
                        ))}
                    </tbody>
                </Table>
            </div>
        </Col>
    );
};

export default memo(SelectTable);